import { render, staticRenderFns } from "./SelectStorage.vue?vue&type=template&id=1ce149e1&scoped=true"
import script from "./SelectStorage.vue?vue&type=script&lang=js"
export * from "./SelectStorage.vue?vue&type=script&lang=js"
import style0 from "./SelectStorage.vue?vue&type=style&index=0&id=1ce149e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce149e1",
  null
  
)

export default component.exports